import { VideoFilePreview } from "../../VideoFilePreview/VideoFilePreview";
import type { FormVideo } from "../../VideoInput/useVideoInput";

export function CommentFieldVideoPreview({
  video,
  onRemoveVideo,
}: {
  video: FormVideo;
  onRemoveVideo?: (video: FormVideo) => void;
}): React.ReactElement {
  return (
    <div data-testid="comment-attachment-video-preview">
      <VideoFilePreview video={video} onDelete={() => onRemoveVideo?.(video)} />
    </div>
  );
}
